module.exports = __webpack_public_path__ + "static/media/sb-logo-dark.495cdad9.svg";